import { render, staticRenderFns } from "./citys.vue?vue&type=template&id=cc28bade&scoped=true"
import script from "./citys.vue?vue&type=script&lang=js"
export * from "./citys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc28bade",
  null
  
)

export default component.exports